import React from 'react';
import {
  Outlet,
  useParams
} from 'react-router';
import PAGES from 'common/pages';
import Progress from 'components/Progress/Progress';
import { makeStyles } from '@mui/styles';
import RadioLeftView from './RadioLeftView';

const drawerWidth = 320;
const useStyles = makeStyles(() => ({
  rightComponent: {
    minWidth: 1000,
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})px`
  }
}));

const RadioContainer = () => {
  const { id } = useParams();
  const classes = useStyles();

  const config = {
    pageName: 'Radios',
    templates: {
      key: (dataItem) => dataItem.id,
      primaryText: (dataItem) => `EBAND-RADIOS-${dataItem.name?.toUpperCase()}`,
      secondaryText: () => { },
      pageLink: (dataItem) => `${PAGES.RADIOS}/${dataItem.id}`,
    },
    isSelectedRow: (dataItem) => dataItem.id.toString() === id,
  };

  if (id) {
    return (
      <>
        <RadioLeftView config={config} />
        <div className={classes.rightComponent}>
          {/* {rightComponent} */}
          <Outlet />
        </div>
      </>
    );
  }

  return <Progress />;
};

export default RadioContainer;
